import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface SortedGameGhostWordProps {
  id: string
}

export function SortedGameGhostWord({ id }: SortedGameGhostWordProps) {
  return (
    <div className="inline-block rounded-lg bg-gray-50 px-5 py-3 text-primary font-bold uppercase cursor-pointer shadow-sm border border-gray-400 z-20 select-none">
      {id}
    </div>
  )
}

interface SortedGameWordProps {
  id: string
  text: string
  disabled?: boolean
}

export function SortedGameWord({ id, text, disabled = false }: SortedGameWordProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id, disabled })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
    whiteSpace: 'normal',
    lineHeight: '1.25rem',
    opacity: isDragging ? 0.7 : disabled ? 0.5 : 1,
    zIndex: isDragging ? 30 : 10
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`
        inline-block rounded-lg bg-gray-50 p-2 px-4 py-2
        text-primary font-bold uppercase cursor-pointer shadow-sm
        border border-gray-400 select-none leading-4 transition-all
        ${isDragging ? 'ring-2 ring-primary' : ''}
        ${disabled ? 'pointer-events-none' : ''}
      `}
    >
      {text}
    </div>
  )
}
